module.exports = __webpack_public_path__ + "media/d3.b262af33.mp3";